import React, { useEffect, useState, } from 'react'
import { Modal } from 'react-bootstrap'
import HtmlParser from 'react-html-parser';

import axios from 'axios';

import 'react-tempusdominus-bootstrap';
import moment from 'moment';

import {
    responseGet, globalSettings, dateTimeFormatGlobalSet, numberSet, separatorsNumbersSet, styles, validateDecimals, sendMessageCloseCurrentWindowAsync, languageObjGet, isUndNullEmp,
    isNumber, awaitDelay,
} from '../../helpers/settings';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { collectionCashMovementModelGet } from '../../models/collections/collectionCashMovement';

const currentMethod = 'CollectionCashMovementAddEditDetails';

const neutralValue = 0.00;
const neutralValueStr = separatorsNumbersSet({
    number: neutralValue,
    withDecimals: true,
    consoleLogErrorShow: true,
    subMethod: currentMethod,
})?.result;

const { icons, labels, messages, } = globalSettings;
const { properties: dbProps, } = globalSettings?.collections;
const { tempusDominus, } = globalSettings?.react;
const { transactionTypes, } = globalSettings.movement;
const { backend, } = globalSettings?.app;

export default function CollectionCashMovementAddEditDetails({
    $ = {},
    auth = {},
    movement = collectionCashMovementModelGet({}),
    setMovement = () => { },
    processType = 0,
    btnMovementSearchId = '',
    showModal = false,
    setShowModal = () => { },
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let dataObj = {};
    let headerObj = {};
    const movementDateId = 'movementDateId';
    const [movementDateError, setMovementDateError] = useState('');
    const [movementTypeError, setMovementTypeError] = useState('');
    const [movementAmountError, setMovementAmountError] = useState('');
    const [movementRemarkError, setMovementRemarkError] = useState('');
    //#endregion variables

    //#region others
    const controls = {
        buttons: {
            save: {
                id: 'btnMovementModalSave',
                className: 'btn btn-outline-primary mx-1',
                classNameTwo: 'btn btn-outline-warning mx-1',
            },
            back: {
                id: 'btnMovementModalBack',
                className: 'btn btn-outline-success',
            },
            close: {
                id: 'btnMovementModalClose',
                className: 'close btn-danger fas fa-window-close',
            },
        },
        dataTables: {
            // movements: {
            //     buttons: {
            //         // detailAdd: {
            //         //     className: 'btn btn-sm btn-outline-info mx-1 float-right',
            //         //     id: 'btnDtPurchaseDetailsIdDetailAdd',
            //         // },
            //     },
            //     icons: {
            //         // detailAdd: {
            //         //     id: 'iconDtPurchaseDetailsIdDetailAdd',
            //         //     className: icons?.list,
            //         // },
            //     },
            //     inputs: {
            //         search: {
            //             id: `${dtMovementsId}_filter input`,
            //             className: '',
            //         },
            //     },
            //     selects: {
            //         entries: {
            //             id: `${dtMovementsId}_length select`,
            //             className: '',
            //         },
            //     },
            //     // spinners: {
            //     //     detailAdd: {
            //     //         id: 'spDtPurchaseDetailsIdDetailAdd',
            //     //         className: '',
            //     //     },
            //     // },
            // },
        },
        icons: {
            save: {
                id: 'icoMovementModalSave',
                className: icons?.save,
            },
            back: {
                id: 'icoMovementModalBack',
                className: icons?.arrowCircleLeft,
            },
            close: {
                id: 'icoMovementModalClose',
                className: '',
            },
        },
        inputs: {
            date: {
                id: 'inputMovementModalDate',
                className: 'form-control bg-transparent text-black',
            },
            amount: {
                id: 'inputMovementModalAmount',
                className: 'form-control text-right',
            },
            remark: {
                id: 'inputMovementModalRemark',
                className: 'form-control',
            },
        },
        radioButtons: {
            // all: {
            //     id: 'rButonAll',
            //     className: 'icheck-primary d-inline',
            //     name: 'radioButtonName',
            // },
        },
        selects: {
            type: {
                id: 'selMovementModalType',
                className: 'form-select',
            },
        },
        spinners: {
            save: {
                id: 'spMovementModalSave',
                className: '',
            },
            back: {
                id: 'spMovementModalBack',
                className: '',
            },
            close: {
                id: 'spMovementModalClose',
                className: '',
            },
        },
    };
    //#endregion others

    //#region methods
    const defaultValueSetAsync = async ({
        isModalClose = false,
        subMethod = '',
    }) => {
        let response = responseGet();
        try {
            if (isModalClose) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                controlsStatusSet({ processType: 2, subMethod: currentMethod, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            }

            setShowModal(!isModalClose);
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const saveChangeAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'saveChangeAsync';
        let response = responseGet();
        try {
            //#region initialize
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }
            //#endregion initialize

            //#region data set
            response = await dataSetAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion data set

            //#region errors default set
            response = await errosDefaultSetAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion errors default set

            //#region form data validate
            response = await validateFormDataAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion form data vakidate

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region create / edit movement
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                collectionCashMovement: movement,
                languageId: languageObj?.id,
                languageCode: languageObj?.code,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlCollectionCashMovements}/`,
            };

            switch (processType) {
                case 0:
                    result = await axios?.post(
                        dataObj?.url,
                        dataObj,
                        headerObj,
                    );
                    break;
                case 1:
                    result = await axios?.post(
                        `${dataObj?.url}${movement?.id}`,
                        dataObj,
                        headerObj,
                    );
                    break;
                default:
                    break;
            }

            response = result?.data || {};
            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion create / edit movement

            await defaultValueSetAsync({
                isModalClose: true,
                subMethod: currentMethod,
            });

            $(`#${btnMovementSearchId}`)?.trigger('click');

            sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataSetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataSetAsync';
        let response = responseGet();
        try {
            //#region variables
            const movementDateLocal = $(`#${movementDateId}`)?.datetimepicker('date')?._d;
            //#endregion variables

            //#region methods
            movement.date = !isUndNullEmp({ data: movementDateLocal, subMethod: currentMethod, })?.result ? movementDateLocal : movement?.date;
            movement.amount = numberSet({
                number: movement?.amount,
                type: 'd',
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dateInControlSetAsync = async ({
        date = new Date(),
        movementDate = undefined,
        subMethod = '',
    }) => {
        const currentMethod = 'dateInControlSetAsync';
        let response = responseGet();
        try {
            //#region variales
            //#region old code
            //let dateTimeObj?.date = '';
            //const dateTimeObj?.format = tempusDominus?.format?.date?.DDMMYYYY;
            //const dateTimeObj?.formatTwo = tempusDominus?.format?.date?.dmy;
            //#endregion old code
            const dateTimeObj = {
                date: '',
                time: 0,
                format: languageObj?.format?.date?.f1,
                formatTwo: languageObj?.format?.date?.f11,
            };
            //#endregion variables

            //#region methods
            if (!isUndNullEmp({ data: movementDate, subMethod: currentMethod, })?.result) {
                dateTimeObj.date = dateTimeFormatGlobalSet({
                    date: movementDate,
                    type: dateTimeObj?.format,
                    format: dateTimeObj?.time,
                    addTime: false,
                    secondsShow: false,
                    subMethod: currentMethod,
                })?.result;
            } else {
                dateTimeObj.date = dateTimeFormatGlobalSet({
                    date: date,
                    type: dateTimeObj?.format,
                    format: dateTimeObj?.time,
                    addTime: false,
                    secondsShow: false,
                    subMethod: currentMethod,
                })?.result;
            }

            $.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
                icons: tempusDominus?.icons,
                buttons: tempusDominus?.buttons,
                tooltips: tempusDominus?.tooltips,
                locale: languageObj?.id,
            });

            $(`#${movementDateId}`).datetimepicker('options', {
                date: moment(dateTimeObj?.date, dateTimeObj?.formatTwo),
                default: false,
                timepicker: false,
                format: dateTimeObj?.formatTwo,
            });
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dataGetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            //#region dateTime in control sets
            response = await dateInControlSetAsync({
                date: new Date(),
                movementDate: movement?.date,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion dateTime in control sets
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const errosDefaultSetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'errosDefaultSetAsync';
        let response = responseGet();
        try {
            setMovementDateError('');
            setMovementTypeError('');
            setMovementAmountError('');
            setMovementRemarkError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const validateFormDataAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'validateFormDataAsync';
        let response = responseGet();
        try {
            //#region variables
            const movementDateLocal = $(`#${controls?.inputs?.date?.id}`)?.val();
            //#endregion variables

            //#region methods
            if (isUndNullEmp({ data: movementDateLocal, subMethod: currentMethod, })?.result ||
                isUndNullEmp({ data: movement?.date, subMethod: currentMethod, })?.result) {
                setMovementDateError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: movement?.remark, subMethod: currentMethod, })?.result) {
                setMovementRemarkError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: movement?.type, subMethod: currentMethod, })?.result) {
                setMovementTypeError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: movement?.amount, subMethod: currentMethod, })?.result ||
                movement?.amount <= 0 ||
                !isNumber({ number: movement?.amount, languageId: languageObj?.id, subMethod: currentMethod, })?.result) {
                //setMovementAmountError(messages?.thisFieldRequired?.[languageObj?.id]);
                //response.isWarning = true;
                setMovementAmountError(`${labels?.amount?.[languageObj?.id]}. ${messages?.mustBeGreaterThan?.[languageObj?.id]} <b>${neutralValueStr}</b>`);
                response.isWarning = true;
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.create?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            $(`#${controls?.inputs?.date?.id}`).attr({ readOnly: (processType !== 0), });
            $(`#${controls?.selects?.type?.id}`).attr({ disabled: (processType !== 0), });
            $(`#${controls?.inputs?.amount?.id}`).attr({ readOnly: (processType !== 0), });
            $(`#${controls?.inputs?.remark?.id}`).attr({ readOnly: (processType !== 0), });
            //#endregion controls

            //#region old code
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion old code

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            // $(`#${controls?.dataTables?.movements?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            // $(`#${controls?.dataTables?.movements?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({
            subMethod: 'form - onLoad',
        });
    }, [showModal]); //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <Modal backdrop='static' onHide={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - onHide', })} show={showModal}>
            <Modal.Header>
                <Modal.Title>
                    <img alt={labels?.movement?.[languageObj?.id]}
                        style={styles?.cardHeaderLogo}
                        src={globalSettings?.images?.movementsLogo}>
                    </img> - {labels?.movement?.[languageObj?.id]} ({processType === 0 ? labels?.add?.[languageObj?.id]?.toLowerCase() : (processType === 1 ? labels?.edit?.[languageObj?.id]?.toLowerCase() : labels?.detail?.[languageObj?.id]?.toLowerCase())})
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    type='button'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnClose', })}>
                </button>
            </Modal.Header>
            <form onSubmit={(e) => saveChangeAsync({ e: e, subMethod: 'form - onSubmit' })}>
                <Modal.Body>
                    {/* <div className='card shadow-lg'> */}
                    {/* <form> */}
                    {/* <div className='card-body'> */}
                    {processType === 0 || processType === 1 ?
                        <div>
                            <div className='row'>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <div id={movementDateId} className='input-group date' data-target-input='nearest'>
                                                <input id={controls?.inputs?.date?.id}
                                                    className={controls?.inputs?.date?.className}
                                                    data-target={`#${movementDateId}`}
                                                    data-toggle='datetimepicker'
                                                    onFocus={() => setMovementDateError('')}
                                                    placeholder={labels?.date?.[languageObj?.id]}
                                                    tabIndex={-2}
                                                    tooltip='tooltip' title={labels?.date?.[languageObj?.id]}
                                                    type='text' />
                                                <div className='input-group-append' data-target={`#${movementDateId}`} data-toggle='datetimepicker'>
                                                    <div className='input-group-text'><i className={icons?.calendarAlt}></i></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(movementDateError)}</div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <select id={controls?.selects?.type?.id}
                                                className={controls?.selects?.type?.className}
                                                defaultValue={movement?.type || ''}
                                                onChange={(e) =>
                                                    setMovement({
                                                        ...movement,
                                                        [dbProps?.type]: e?.target?.value,
                                                    })
                                                }
                                                onFocus={() => setMovementTypeError('')}
                                                tooltip='tooltip' title={labels?.buildings?.[languageObj?.id]}>
                                                <option key='nothing' value=''>{messages?.selectType?.[languageObj?.id]}</option>
                                                {transactionTypes?.map((detail) => (
                                                    <option key={detail?.id} value={detail?.id}>{detail?.description?.[languageObj?.id]}</option>
                                                ))}
                                            </select>
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className='fas fa-sort' />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(movementTypeError)}</div>
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input id={controls?.inputs?.amount?.id}
                                                className={controls?.inputs?.amount?.className}
                                                onChange={(e) =>
                                                    setMovement({
                                                        ...movement,
                                                        [dbProps?.amount]: validateDecimals({ e: e, languageId: languageObj?.id, subMethod: currentMethod, })
                                                    })
                                                }
                                                onFocus={() => setMovementAmountError('')}
                                                placeholder={labels?.amount?.[languageObj?.id]}
                                                tooltip='tooltip' title={labels?.amount?.[languageObj?.id]}
                                                value={movement?.amount || '0.00'} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.moneyBillWave} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(movementAmountError)}</div>
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <textarea id={controls?.inputs?.remark?.id}
                                                className={controls?.inputs?.remark?.className}
                                                placeholder={labels?.remark?.[languageObj?.id]}
                                                onChange={(e) =>
                                                    setMovement({
                                                        ...movement,
                                                        [dbProps?.remark]: e?.target?.value,
                                                    })
                                                }
                                                onFocus={() => setMovementRemarkError('')}
                                                value={movement?.remark || ''}
                                                tooltip='tooltip' title={labels?.remark?.[languageObj?.id]}>
                                            </textarea>
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.edit} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(movementRemarkError)}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <></>
                    }
                    {/* </div> */}

                    {/* <div className='card-footer'>
                            <div className='form-group text-right'>
                                <button className={processType === 0 ? 'btn btn-outline-primary mx-1' : 'btn btn-outline-warning mx-1'}
                                    tooltip='tooltip' title={labels?.save?.[languageObj?.id]}
                                    type='submit'
                                    onClick={(e) => saveChangeAsync(e)}
                                    hidden={processType !== 0 && processType !== 1}>
                                    <i className={icons?.save}></i>
                                </button>
                                <button className='btn btn-outline-success'
                                    tooltip='tooltip' title={labels?.close?.[languageObj?.id]}
                                    type='button'
                                    onClick={() => defaultValueSetAsync(true)}>
                                    <i className={icons?.arrowCircleLeft}></i>
                                </button>
                            </div>
                        </div> */}
                    {/* </form> */}
                    {/* </div> */}
                </Modal.Body>
                <Modal.Footer>
                    <div className='form-group text-right'>
                        <button id={controls?.buttons?.save?.id}
                            className={processType === 0 ? controls?.buttons?.save?.className : controls?.buttons?.save?.classNameTwo}
                            tooltip='tooltip'
                            title={labels?.save?.[languageObj?.id]}
                            type='submit'
                            hidden={processType !== 0 && processType !== 1}>
                            <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                        </button>
                        <button id={controls?.buttons?.back?.id}
                            className={controls?.buttons?.back?.className}
                            tooltip='tooltip'
                            title={labels?.close?.[languageObj?.id]}
                            type='button'
                            onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnClose', })}>
                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}